import React, { ReactElement, Component, useMemo, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { Row } from "antd";
import { Link, withRouter } from "react-router-dom";

const UseMenu = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const { formatMessage } = useMemo(() => props.intl, [props.intl]),
            [active_key, set_active_key]: [string, React.Dispatch<React.SetStateAction<string>>] = useState(""),
            path = props.history.location.pathname.substring(1),

        menu_new: JSX.Element[] = useMemo((): JSX.Element[] => {
            const menu_new_new: JSX.Element[] = [];
            menu_new_new.push(
                <div className="w-100 pr-10">
                    <div className="mt-10 w-100" key="resourceOverview">
                        <Link to={`/resource/view`}>
                            <div className={`left_menu_button w-110 ${active_key === 'resourceOverview' ? 'active' : ''} text-left`}
                            onClick={() => {
                                set_active_key('resourceOverview');
                              }}
                            >{formatMessage({ id: "resource_overview" })}</div>
                        </Link>
                    </div>
                    <div className="mt-10 w-100" key="resourceService">
                        <Link to={`/resource/service`}>
                            <div className={`left_menu_button w-110 ${active_key === 'resourceService' ? 'active' : ''} text-left`}
                            onClick={() => {
                                set_active_key('resourceService');
                              }}
                            >{formatMessage({ id: "resource_service" })}</div>
                        </Link>
                    </div>
                </div>

            );
            return menu_new_new;
        }, [formatMessage, active_key]);

    useEffect(() => {
        path === "resource/service" ? set_active_key("resourceService") : set_active_key("resourceOverview");
    },[path])

    return <Row>{menu_new}</Row>;
};

export default injectIntl(withRouter(UseMenu) as any);
